module.exports = __webpack_public_path__ + "static/media/minus.53e4ee44.svg";